import { FileDown } from "lucide-react";

// Shared chrome for the customer-facing estimate / invoice pages: light, print-friendly, the SHOP's brand up top (Xpattern only in the footer).
export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const when = (iso, time = false) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric", ...(time ? { hour: "numeric", minute: "2-digit" } : {}) }) : "");
const STATUS = { draft: ["Draft", "#64748b"], sent: ["Sent", "#2563eb"], viewed: ["Viewed", "#2563eb"], accepted: ["Accepted", "#15803d"], declined: ["Declined", "#b91c1c"], expired: ["Expired", "#64748b"], partial: ["Partially paid", "#b45309"], paid: ["Paid", "#15803d"], void: ["Void", "#64748b"] };

export const PubShell = ({ brand = {}, doc, number, status, meta = [], pdf, testId, children }) => {
  const st = STATUS[status];
  const contact = [brand.phone, brand.email, brand.website].filter(Boolean);
  return (
    <div className="pub-root" data-testid={testId}>
      <div className="pub-sheet">
        <header className="pub-head">
          <div className="pub-brand">
            {brand.logo_url && <img src={brand.logo_url} alt="" className="pub-logo" data-testid="pub-logo" />}
            <div><div className="pub-shop" data-testid="pub-shop-name">{brand.name}</div>{brand.address && <div className="pub-muted">{brand.address}</div>}{contact.length > 0 && <div className="pub-muted">{contact.join(" · ")}</div>}</div>
          </div>
          {doc && <div className="pub-docid">
            <div className="pub-doc">{doc}</div><div className="pub-number" data-testid="pub-number">{number}</div>
            {st && <span className="pub-status" style={{ "--st": st[1] }} data-testid="pub-status">{st[0]}</span>}
          </div>}
        </header>
        {meta.length > 0 && <dl className="pub-meta">{meta.map(([k, v]) => v ? <div key={k}><dt>{k}</dt><dd>{v}</dd></div> : null)}</dl>}
        {children}
        <footer className="pub-foot">
          <span>{brand.name}{brand.phone ? ` · ${brand.phone}` : ""}</span>
          <span className="flex items-center gap-3">{pdf && <a href={pdf} target="_blank" rel="noreferrer" className="pub-link inline-flex items-center gap-1 print:hidden"><FileDown className="h-3.5 w-3.5" /> PDF</a>}<span>Powered by <b>Xpattern</b></span></span>
        </footer>
      </div>
    </div>
  );
};

export const PubTotals = ({ rows, caption = "", inline = false }) => (
  <div className={`pub-totals ${inline ? "is-inline" : ""}`} data-testid="pub-totals">
    {caption && <div className="pub-muted mb-1">{caption}</div>}
    {rows.map(([k, v, kind], i) => <div key={i} className={`pub-tot ${kind ? `is-${kind}` : ""}`}><span>{k}</span><span>{v}</span></div>)}
  </div>
);
